import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-help-list',
  templateUrl: './help-list.page.html',
  styleUrls: ['./help-list.page.scss'],
})
export class HelpListPage implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private dataService: DataService) {}

  ngOnInit() {}

  goHelp(type) {
    this.dataService.setData(this.activatedRoute.snapshot.paramMap.get('id'), type);
    this.router.navigate([
      '/tecservice/home/business/' + this.activatedRoute.snapshot.paramMap.get('id') + '/help/',
      type,
    ]);
  }
}
